import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../../services/auth.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IonicHelper } from "../../../helpers/ionic.helper";
import * as moment from "moment";
import { NavController } from "ionic-angular";
import { PageTitleService } from "../../../services/page-title.service";
import { ViewDidEnter } from "../../../app/app.interfaces";

@Component({
  selector: 'login',
  templateUrl: 'login.html'
})
export class Login implements ViewDidEnter {
  
  form: FormGroup;  
  greeting: string = 'GOOD_MORNING';
  showErrors: boolean = false;

  constructor(private formBuilder: FormBuilder, 
              private authService: AuthService,    
              private nav: NavController,
              private ionic: IonicHelper,
              private pageTitleService: PageTitleService
              ) {
    
    
    
  }

  ionViewDidEnter(): void {    
    
    this.authService.isLoggedIn().then((loggedIn)=> {     
      if(loggedIn) this.nav.setRoot('dashboard');
    });
    
    this.pageTitleService.setPageTitle('login');
    
    this.form = this.formBuilder.group({
        email: ['', Validators.compose([Validators.maxLength(60), Validators.email, Validators.required])],
        password: ['', Validators.compose([Validators.maxLength(60), Validators.required])],
        rememberLogin: [true]
    });
    
    const hour = parseInt(moment().format('H'),10);
    if(hour >= 12) this.greeting = 'GOOD_AFTERNOON';
    if(hour >= 18) this.greeting = 'GOOD_EVENING';
        
  }
  
  
  submitForm(){
    
    this.showErrors = true;
    
    if(this.form.valid){
    
      this.ionic.toggleLoader();
      
      this.authService.login(this.form.value)
        .then(() =>{
          this.ionic.toggleLoader(false);
            this.nav.setRoot('dashboard');
        }, () => {
          
          this.ionic.toggleLoader(false);
          this.ionic.alert('LOGIN.WRONG_CREDENTIALS_MSG','LOGIN.WRONG_CREDENTIALS_TITLE');  
          
        });
              
    }
    else {
      this.ionic.alert('LOGIN.WRONG_INPUT_MSG','LOGIN.WRONG_CREDENTIALS_TITLE');
    }
    
  }
  
  
}


// WEBPACK FOOTER //
// ./src/components/login/login/login.ts